/**
 * Уровни логирования.
 *
 * Уровни логгирования используются в следующих сценариях.
 *
 *  * Маркировка событий при логгировании
 *  * Конфигурация детализации лога
 *
 *  ## Маркировка событий при логгировании
 *
 *  Выполняется разработчиком при написании кода.
 *  Разработчик решает, с каким уровнем должно быть сохранено то или иное
 *  событие, но НЕ решает какие события будут записаны в лог (см. Конфигурация
 *  детализации лога).
 *  При выборе уровня необходимо учитывать следующие аспекты:
 *
 *  * Степень влияния события (severity) на работоспособность системы: INFO, WARN, ERROR
 *  * Уровень детализации технических событий:  DEBUG, TRACE
 *  * Уровни ALL, OFF не используются для маркировки событий
 *
 *  ## Конфигурация детализации лога
 *
 *  Выполняется лицом, отвечающим за конфигурацию приложения.
 *  В конфигурации уровень используется как порог.
 *  Сохраняются только те события, которые соответствуют заданому порогу и всем
 *  менее детальным уровням.
 *
 *  Примеры:
 *  * threshold = ALL   : логгируются все события
 *  * threshold = DEBUG : DEBUG, INFO, WARN, ERROR
 *  * threshold = INFO  : INFO, WARN, ERROR
 *  * threshold = WARN  : WARN, ERROR
 *  * threshold = ERROR : ERROR
 *  * threshold = OFF  : отключены все события
 *
 *  Развитые системы логгирования позволяют указывать порог в том числе и для
 *  каждого логгера в отдельности.
 */
export enum LoggingLevel {
  /**
   * Сохраняются все события, фильтрация по уровням отключена.
   */
  ALL,

  /**
   * Событие содержит очень детальную информацию (например
   * трафик обмена данынми с сервером)
   *
   * В конфигурации используется редко и на кототкий срок, так как сильно
   * засоряет логи.
   */
  TRACE,

  /**
   * Событие содержит детальную/отладочную информацию.
   *
   * Как правило используется для вывода технической информации.
   */
  DEBUG,

  /**
   * Информационные сообщения.
   *
   * Как правило используется для вывода бизнес значимых событий.
   */
  INFO,

  /**
   * Предупреждение.
   *
   * Что-то пошло не так, но система продолжает работать корректно.
   *
   * Примеры:
   *  * попытка отправки уведомления закончилась неудачно (при этом есть еще попытки)
   */
  WARN,

  /**
   * Ошибка.
   *
   * Не удалось выполнить какое-либо действие.
   *
   * Примеры:
   *  * не удалось отправить уведомление, все попытки исчерпаны
   *  * сервер прислал неверный формат данных
   */
  ERROR,

  /**
   * События не сохраняются.
   *
   * Эквивалентно отключению логгирования.
   */
  OFF,
};